import axios from 'axios';

// axios を require してインスタンスを生成する
var axiosBase = require('axios');
var axiosLoader = axiosBase.create({
  baseURL: '', // バックエンドB のURL:port を指定する
  headers: {
    'ContentType': 'text/html',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'text'
});

//morebuttonの挙動
const moreButtonElements = document.querySelectorAll('.more-button');

if (moreButtonElements.length > 0) {
    moreButtonElements.forEach(button => {
        //
        button.addEventListener( 'click', function (event) {
            event.preventDefault();
            const target = this;
            const append_element = target.previousElementSibling;
            target.innerHTML = '読み込んでいます';
            target.disabled = true;
            append_element.classList.add('loading-items');
            //console.dir(target, append_element);
            axios({
                method : 'GET', 
                responseType : 'document', 
                url : target.getAttribute('href'),
            })
            .then(function(response) {
                const url = new URL(response.data.URL);
                const offset = Number(url.searchParams.get('offset'));
                const unit = Number(url.searchParams.get('unit'));
                append_element.classList.remove('loading-items');
                //console.log('nodelength', response.data.body.childNodes.length);
                if(response.data.body.childNodes.length == 0){
                    window.alert('すべて読み込みました');
                    target.innerHTML = '';
                    target.style.display = 'none';
                }else if(response.data.body.childNodes.length < unit * 2){ //nodeが改行を含む
                    target.innerHTML = '';
                    target.style.display = 'none';
                }else{
                    target.innerHTML = 'さらに読み込む';
                }
                Array.from(response.data.body.childNodes).forEach((node) => {
                    append_element.appendChild(node);
                    if(node.nodeName == '#text') { return; }
                    loadImages(node);
                    //console.log('apeend', node);
                });
                url.searchParams.set('offset', offset+unit);
                //console.log(url.search); 
                target.setAttribute('href', url),
                target.disabled = false;
            })
            .catch(function(error) {
                //console.log(error,'ERROR!! happend by Backend.');
            });
            return false;
        });
        //
    });
}

function loadImages(node) {
    const images = node.querySelectorAll('img');
    if (images.length == 0) { return; }

    images.forEach(img => {
        //.loading-square
        const placeholder = document.createElement('div');
        placeholder.className = 'loading-square';
        img.parentElement.insertBefore(placeholder, img);
        img.classList.add('fade-image');

        img.onload = function() {
            placeholder.style.display = 'none'; // プレースホルダーを隠す
            setTimeout(function() {
                img.style.opacity = 1; // 画像をフェードイン
            }, 400); // CSSのtransition-durationと同じ時間
        };

        // 画像がキャッシュからでもロードイベントが発火するように
        if (img.complete) {
            img.onload();
        }
    });
};
